import { useState, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SiteStudySidebar from '../components/SiteStudySidebar';
import Header from '../components/Header';
import LoadingSpinner from '../components/LoadingSpinner';
import { SiteStudyProvider } from '../contexts/SiteStudyContext';

const SiteStudyLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <SiteStudyProvider>
      <div className="flex h-screen overflow-hidden bg-slate-100">
        <SiteStudySidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <main>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
              <Suspense fallback={<LoadingSpinner />}>
                <Outlet />
              </Suspense>
            </div>
          </main>
        </div>
      </div>
    </SiteStudyProvider>
  );
};

export default SiteStudyLayout;
